import { SiteMode } from '@shared/services/hostMode.service';
import { PassTlsClientCert } from '@shared/services/organization-site.service';
import { UrlScheme } from '@shared/services/site.service';
import { TlsOptions } from '@shared/services/organization-tls-options.service';
import { ClusterConfig } from '@shared/services/organization-cluster.service';

import { CustomPagesProfileModel } from '@shared/services/custom-page-profiles/organization-custom-pages-profile.service';
import { OrganizationBase } from '@shared/services/organization.service';

export interface DomainName {
  domainName: string;
}

export interface Site extends DomainName {
  mode: SiteMode;
  owner: OrganizationBase;
  cluster: Cluster;
  secondaryCluster: Cluster;
  contract: Contract;
  status: string;
  createdAt: string;
  updatedAt: string;
  customPagesProfile: CustomPagesProfileModel;
  originServer: string;
  originScheme: UrlScheme;
  originDisableHttp2: boolean;
  originPort: number;
  originMtlsEnabled: boolean;
  originSkipCertVerify: boolean;

  forceHttps: boolean;
  hsts: Hsts;
  tlsOptions: TlsOptions;
  passTlsClientCert: PassTlsClientCert;

  removeXForwarded: boolean;
  passthroughMode: boolean;
  auditMode: boolean;
  logExportEnabled: boolean;
  cacheEnabled: boolean;
  cdn: string;
  cdnStatus: CdnStatus;
  ddosProtection: boolean;

  letsEncryptCertificateFallbackEnabled?: boolean;

  tags: string[];
  accessRights: string[];

  isACertificateInError: boolean;
}

export type BaseCluster = {
  uid: string;
  name: string;
};

export type Cluster = ClusterConfig & BaseCluster & {
  uid: string;
  name: string;
  ip: string;
  ipv6?: string;
  trustedIps: string[];
  isPublic: boolean;
  entryPointIpv4?: string;
  entryPointIpv6?: string;
};

export interface Contract {
  number: string;
  name: string;
  cdnEnabled: boolean;
  secondaryClusterEnabled: boolean;
}

export const Policies = ['allow', 'deny'] as const;
export type Policy = (typeof Policies)[number];

export const RuleActions = ['brain', 'bypass'] as const;
export type RuleAction = (typeof RuleActions)[number];
export const ruleAction: Record<RuleAction, string> = {
  brain: 'RequestAnalyzed',
  bypass: 'RequestNotAnalyzed',
};

export type Hsts = 'none' | 'hsts' | 'hstss' | 'hstssp';
export type CdnStatus = 'ACTIVE' | 'ACTIVATION_IN_PROGRESS' | 'SYNC_IN_PROGRESS';
